import { render, staticRenderFns } from "./Edit.modal.vue?vue&type=template&id=58805a58&"
import script from "./Edit.modal.vue?vue&type=script&lang=js&"
export * from "./Edit.modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports